// extracted by mini-css-extract-plugin
export var closeDefault = "ApplyNowCTA-module--closeDefault--78559";
export var input = "ApplyNowCTA-module--input--4655a";
export var isLoading = "ApplyNowCTA-module--is-loading--84e27";
export var spin = "ApplyNowCTA-module--spin--8dc58";
export var wrapper = "ApplyNowCTA-module--wrapper--9e80e";